import { Badge } from '@Components/ui-v2/badge';

export type EmptyStateTone = 'ready' | 'pending';

interface GreetingHeadingProps {
  tone: EmptyStateTone;
  submitted: boolean;
  name?: string;
}

const GreetingHeading = ({ tone, submitted, name }: GreetingHeadingProps) => {
  if (submitted) {
    const firstName = name?.split(' ')[0];
    return (
      <>
        <h1 className="text-4xl font-bold tracking-tight leading-[1.1] mb-3.5">
          You&apos;re on the list{firstName ? `, ${firstName}` : ''}.
        </h1>
        <p className="text-base text-gray-500 leading-relaxed max-w-[520px] mx-auto">
          We&apos;ll email you the moment your workspace is provisioned. In the meantime, your administrator has been
          notified of your request.
        </p>
      </>
    );
  }

  if (tone === 'pending') {
    return (
      <>
        <div className="mb-4">
          <Badge variant="brand" dot>
            Access pending
          </Badge>
        </div>
        <h1 className="text-4xl font-bold tracking-tight leading-[1.1] mb-3.5">Your workspace is almost ready.</h1>
        <p className="text-base text-gray-500 leading-relaxed max-w-[520px] mx-auto">
          You&apos;re signed in, but your organization is still being provisioned. An administrator will grant access
          shortly — usually within one business day.
        </p>
      </>
    );
  }

  return (
    <>
      <h1 className="text-[38px] font-bold tracking-tight leading-[1.1] mb-3.5">
        Welcome to{' '}
        <span className="bg-[linear-gradient(90deg,#7c6cf6,#c850c0,#4facfe,#7c6cf6)] bg-[length:200%_auto] bg-clip-text text-transparent animate-es-gradient">
          Bops
        </span>
        .
      </h1>
      <p className="text-base text-gray-500 leading-relaxed max-w-[540px] mx-auto">
        We&apos;re putting the finishing touches on your workspace — connecting your data sources, aligning your agents,
        and preparing your dashboards. We&apos;ll let you know the moment it&apos;s ready.
      </p>
    </>
  );
};

export default GreetingHeading;
